var _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_423_1122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2V22H22V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_423_1122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_423_1122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.999998H23V23H1V0.999998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_423_1122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7307 3.57754C20.5893 3.43625 20.4219 3.36558 20.2286 3.36558C20.132 3.36558 19.9294 3.44359 19.6208 3.5998C19.3124 3.75601 18.9851 3.93066 18.6394 4.12394C18.294 4.31726 17.8847 4.49187 17.4128 4.64808C16.9406 4.80429 16.5038 4.8823 16.1025 4.8823C15.7306 4.8823 15.4034 4.81164 15.1207 4.67046C14.1839 4.23172 13.3701 3.90453 12.6784 3.68894C11.987 3.47332 11.2436 3.36558 10.448 3.36558C9.07247 3.36558 7.36228 4.038 5.60767 4.93019V14.6854C7.63001 13.5998 9.35493 13.0571 10.7825 13.0571C11.3252 13.0571 11.8549 13.1389 12.3715 13.3024C12.8882 13.466 13.3176 13.6445 13.6596 13.8376C14.0018 14.0309 14.405 14.2096 14.8697 14.3731C15.3346 14.5364 15.7936 14.6183 16.2471 14.6183C17.3922 14.6183 18.764 14.1872 20.3624 13.3246C20.5633 13.2205 20.7099 13.1184 20.8029 13.018C20.8959 12.9177 20.9424 12.7746 20.9424 12.5886V4.07914C20.9424 3.88593 20.8718 3.71875 20.7307 3.57754Z",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35895 2.59448C5.04833 2.59448 5.60702 3.14828 5.60637 3.83767C5.60339 7.00467 5.59543 15.4564 5.59097 20.1473C5.59097 20.8362 5.0325 21.3948 4.34355 21.3948C3.65461 21.3948 3.09613 20.8362 3.09613 20.1473C3.10059 15.4553 3.10855 7.00058 3.11153 3.83537C3.11218 3.1469 3.67047 2.59448 4.35895 2.59448Z",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.db4699801bda44f964b7a2e41c6451bd.svg";
export { ForwardRef as ReactComponent };